/**
 * The body of a storage delete confirmation (UI/UX fix round A, review U15): where, the listed items with a folder or
 * file glyph (a folder says what goes with it), the count of the rest, a Recovery block, and the irreversibility line.
 */
import { File, Folder } from 'lucide-react';
import { IRREVERSIBLE_LINE, type DeleteConfirmationBody } from './deleteConfirmationCopy';

export function DeleteConfirmationView({ body, testId }: { body: DeleteConfirmationBody; testId: string }) {
  return (
    <span className="flex flex-col gap-3 text-left text-sm" data-testid={testId}>
      {body.location && <span className="text-xs text-muted-foreground" data-testid="storage-delete-location">From <span className="font-medium text-foreground break-words">{body.location}</span></span>}
      <span className="flex flex-col gap-1" role="list" data-testid="storage-delete-items">
        {body.items.map((item, index) => {
          const Glyph = item.folder ? Folder : File;
          return (
            <span key={`${index}:${item.label}`} role="listitem" className="flex items-start gap-2">
              <Glyph className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${item.folder ? 'text-amber-700 dark:text-amber-400' : 'text-muted-foreground'}`} aria-hidden="true" />
              <span className="min-w-0 break-words"><span className="text-foreground">{item.label}</span>{item.detail && <span className="text-muted-foreground"> — {item.detail}</span>}</span>
            </span>
          );
        })}
        {body.more > 0 && <span role="listitem" className="pl-5 text-muted-foreground" data-testid="storage-delete-more">and {body.more} more</span>}
      </span>
      <span className="flex flex-col gap-0.5 rounded-md border border-border bg-muted/40 px-3 py-2 text-xs" data-testid="storage-delete-recovery">
        <span className="font-medium text-foreground">Recovery</span>
        {body.recovery.map((line) => <span key={line} className="text-muted-foreground">{line}</span>)}
      </span>
      {body.irreversible && <span className="font-medium text-foreground" data-testid="storage-delete-irreversible">{IRREVERSIBLE_LINE}</span>}
    </span>
  );
}
